import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';
import { GlobalService } from './_services/global.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [Title]
})
export class AppComponent implements OnInit {

  constructor(
    private translate: TranslateService, 
    private globalService: GlobalService,
  ) {
   
    translate.addLangs(['it', 'en']);

    if (this.globalService.locale) {
      const browserLang = this.globalService.locale;
      translate.use(browserLang.match(/en|it/) ? browserLang : 'en');
    } else {
      
     
      translate.setDefaultLang('it');
    }
  }

  ngOnInit() {
  }

}